module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"addProduct":"Artikel hinzufügen","products":"Artikel","number":"Nummer","title":"Bezeichnung","print":"Drucken","group":"Gruppe","count":"Anzahl","price":"Preis"},"en":{"addProduct":"Add product","products":"Products","number":"Number","title":"Title","print":"Print","group":"Group","count":"Count","price":"Price"}}')
  delete Component.options._Ctor
}
